export default {
  title: "Профиль",
  buttons: {
    logout: "Выйти",
  },
  labels: {
    email: "Почта",
    phone: "Номер телефона",
  },
  placeholders: {
    notSpecified: "Не указан",
  },
  sections: {
    usefulContacts: "Полезные контакты",
  },
  notifications: {
    profileChanges:
      "При необходимости изменения данных, обратитесь, пожалуйста в службу поддержки по телефону {phone}, в мессенджерах {telegram}, {whatsapp} или на почту {email}.",
  },
  tariff_badge: {
    lite_p: "Лайт",
    promo_p: "Промо",
    basic: "Базовый",
    pluspro_p: "Про+",
    corporate: "Корпоративный",
  },
  tariff_hint:
    "Подписка отсутствует, выберите тариф для доступа ко всем функциям",
  choose_tariff_button: "Выбрать тариф",

  contactCard: {
    titles: {
      priorityService: "Приоритетное обслуживание",
      distributor: "Дистрибьютор",
    },
    hints: {
      upgradeTariff:
        "При подключении к платному тарифу, вам будут доступны контакты персонального менеджера",
    },
    upgradeTariff: {
      message:
        "Решайте свои вопросы быстрее с персональным менеджером на платном тарифе.",
      button: "Купить тариф",
    },
    extNumber: "доб.",
  },
  managerSchedule: {
    todayWithTime: "Сегодня {time} (МСК)",
    todayDayOff: "Сегодня - Выходной",
    weekdays: {
      monday: "Понедельник",
      tuesday: "Вторник",
      wednesday: "Среда",
      thursday: "Четверг",
      friday: "Пятница",
      saturday: "Суббота",
      sunday: "Воскресенье",
    },
  },
};
